<template>
    <div class="animated fadeIn">
      <div class="col-sm-12 col-md-12">
        <div class="loading" v-if="processando">
          <div class="progress">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div id="veiculoPeriodo">
                  <div class="panel panel-default">
                    <div class="panel-body">
                      <div class="row row-margin">
                        <div id="lista-veiculos" class="col-md-12">
                          <h3 class="panel-title">Veículo:</h3>
                          <input id="veiculoId" type="hidden" class="form-control" v-model="veiculoId">
                          <input id="clienteId" type="hidden" class="form-control" v-model="clienteId">
                          <div class="row">
                            <div class="col-md-8">
                              <input id="busca" name="busca" placeholder="Filtrar veículo" class="form-control" type="text" v-model="buscaVeiculo" v-on:keyup.enter="buscarGrid"> 
                            </div>
                            <div class="col-md-4">
                              <button class="btn btn-success btn-lock" @click="buscarGrid">Buscar</button>
                            </div>
                          </div>
                          <div id="dados-analise-jornada-lista-veiculos">
                            <table class="table table-responsive-sm table-hover table-outline mb-0">
                              <thead class="thead-light">
                                <tr>
                                  <th>Veículo</th>
                                </tr>
                              </thead>
                              <tbody v-for="(grid, i) in dadosGrid">
                                <template v-if="i === 0">
                                  <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                    <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                  </tr>
                                </template>
                                <template v-if="i > 0">
                                  <template v-if="dadosGrid[i].clienteIdVeiculo != dadosGrid[i-1].clienteIdVeiculo">
                                  <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                                    <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                                  </tr>
                                  </template>
                                </template>
                                <tr :class="{ 'selecionado': selecionado(grid) }" @click="selecionarItem(grid)" v-on:dblclick="editar(grid.idVeiculo)">
                                  <td><small class="text-muted">{{grid.descricaoVeiculo}}</small></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <br>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row row-margin">
                  <div class="col-md-12">
                <div id="opcoesRelatorio">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Análise</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row row-margin">
                        <div class="col-md-12">
                          <label>Período:</label><br>
                        </div>
                      </div>
                      <div class="row row-margin">
                        <div class="col-md-6">
                          <label>Data inicial:</label><br>
                          <input-data-picker v-model="dataInicial" class="form-control pula data" />
                        </div>
                        <div class="col-md-6">
                          <label>Hora inicial: </label><br>
                          <input-hora-picker v-model="horaInicial" class="form-control pula hora" />
                        </div>
                      </div>
                      
                      <div class="text-right">
                        <small>*Os dados de rastreamento ficam armazenados por 90 dias.</small>
                      </div>
                      <br/><br/>
                    
                      <div class="col-md-12">
                        <button id="gerarRelatorio" type="button" class="btn btn-success btn-lg btn-block" v-on:click="gerarAnalise">
                          <span class="glyphicon glyphicon-star" aria-hidden="true"></span> Gerar Análise
                        </button>
                      </div>
                      <br>
                      <template v-if="$auth.check('P116')">
                        <div class="col-md-12"> 
                          <button id="gerarRelatorio" type="button" class="btn btn-danger btn-lg btn-block" v-on:click="gerarAnaliseFrota">
                            <span class="glyphicon glyphicon-star" aria-hidden="true"></span> Gerar Análise Frota
                          </button>
                        </div>
                      </template>
                    
                    </div>
                  </div>
                </div>
              </div>
            </div>
               </div>
             </div>
           </div>
         </div> 
       </div>                               
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data () {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    }
  },
  mounted () {
    // this.buscarVeiculos()
    this.buscarGrid()
  },
  methods: {
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    setarVeiculo: function (veiculo) {
      this.model.veiculoId = veiculo.id
      this.model.veiculoDescricao = veiculo.descricaoVeiculo
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo)
    },
    verificarVeiculo: function () {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0
        this.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0
        this.veiculoDescricao = ''
        $(this.$el).find('#veiculoId').val(0)
        $(this.$el).find('#veiculoDescricao').val('')
      }
    },
    buscarGrid: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGrid = dadosCadastro
        self.processando = false
      })
    },
    buscarVeiculos: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/listarVeiculos?busca=' + this.buscaVeiculo
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculos = dadosCadastro
        self.processando = false
      })
    },
    gerarAnalise: function () {
      var self = this
      var veiculoId = self.selecionada
      var dataHoraInicial = self.dataInicial + ' ' + self.horaInicial
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-')
      let dataHoraFinal = moment(dataHoraInicial, 'DD/MM/YYYY HH:mm:ss')
      dataHoraFinal.add(3, 'days')
      dataHoraFinal = moment(dataHoraFinal).format('DD/MM/YYYY HH:mm:ss')
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-')
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção')
        return
      }
      self.processando = true
      // var dadosCadastro
      // var config = {
      //   headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      // }
      // var url = '/api/analiseJornadasView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal
      this.$router.replace('/analiseJornadaView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal)
      // axios.get(url, config)
      // .then(function (response) {
      //   console.log(response.data)
      //   dadosCadastro = response.data
      //   self.dadosVeiculos = dadosCadastro
      //   self.processando = false
      // })
    },
    gerarAnaliseFrota: function () {
      let self = this
      var veiculoId = self.selecionada
      var dataHoraInicial = self.dataInicial + ' 00:00:00'
      var dataHoraFinal = self.dataInicial + ' 23:59:59'
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      // veiculoId = 2679
      var url = '/api/verificarAnaliseJornadasMultiplas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        // if (response.data === 'EXISTE') {
        //   self.$toastr('error', 'Já EXISTEM Jornadas nesse dia, não é possível gerar Automatimente.', 'Atenção')
        // } else {
        {
          let message = 'Deseja realmente gerar as Jornadas ?'
          let options = {
            html: false, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
            loader: true, // set to true if you want the dailog to show a loader after click on "proceed"
            reverse: false, // switch the button positions (left to right, and vise versa)
            okText: 'Sim',
            cancelText: 'Não',
            animation: 'zoom', // Available: "zoom", "bounce", "fade"
            type: 'basic', // coming soon: 'soft', 'hard'
            verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
            clicksCount: 3 // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
          }
          self.$dialog.confirm(message, options)
          .then((dialog) => {
            self.processando = true
            url = '/api/analiseJornadasMultiplasFrota?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal
            axios.get(url, config)
            .then(function (response) {
              console.log(response.data)
              dadosCadastro = response.data
              self.dadosAnalise = dadosCadastro
              self.dadosAnaliseMacros = dadosCadastro.dadosMacros
              self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados
              self.processando = false
              dialog.close()
            })
          })
          .catch(function () {
            console.log('Clicked on cancel')
          })
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/views/jornadasconvencoes/AnaliseJornadasConvencao.vue